import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: 'input[disableAutocomplete], ng-select[disableAutocomplete]'
})
export class DisableAutocompleteDirective implements AfterViewInit {
  constructor(private host: ElementRef) {}

  ngAfterViewInit(): void {
    const el = this.host.nativeElement;

    if (el.tagName.toLowerCase() === 'input') {
      this.applyAttributes(el);

      return;
    }

    const input = el.querySelector('input');
    if (input) {
      this.applyAttributes(input);
    }
  }

  private applyAttributes(input: HTMLElement): void {
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'none');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');
  }
}
